import { Content, ContentsResponse } from "@robe/core";
import { useData } from "./useData";

type UseMultipleContentsValue<T extends Content[]> = {
  [K in keyof T]: ContentsResponse<T[K]>;
};

/**
 * @returns full response for contents fetched in the `multipleContents`
 *
 * @param contents Array of multiple contents.
 * @param options Options provided in query.
 * @param pagination Pagination from `options` and computed range from `content-range` header.
 */
export const useMultipleContentsFullResponse = <TSource extends Content[]>(): UseMultipleContentsValue<TSource> => {
  const { multipleContents } = useData<Content, Content[], TSource>();

  return multipleContents;
};
